<template>
  <article class="text-white bg-gray-900 w-full border border-gray-700">
    <header class="flex items-center justify-between p-2 border-b border-gray-700 shadow">
      <slot name="header" />
      <slot name="button">
        <FontAwesomeIcon
          class="cursor-pointer transition-transform duration-300 ease-in-out"
          :class="expanded ? 'rotate-180' : 'rotate-0'"
          :icon="'chevron-up'"
          @click="$emit('toggle')"
        />
      </slot>
    </header>

    <section v-show="expanded" class="collapsible-container animate-slide">
      <div class="content">
        <slot />
      </div>
    </section>
  </article>
</template>

<script lang="ts" setup>
defineProps({
  expanded: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['toggle'])
</script>

<style scoped>
.collapsible-container {
  transition: max-height 0.3s ease;
}

.collapsible-container.collapsed {
  max-height: 0rem;
}

.animate-slide {
  animation: slideDown 0.3s ease 1;
}

@keyframes slideDown {
  from {
    transform: translateY(50%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
